import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-16 flex gap-10',
    sidebar:
      'sticky top-[calc(var(--head-fixed-height)+40px)] h-full w-fit flex-0 max-md:hidden',
    comments: 'grow',
    mobileRating: 'mb-8 md:hidden',
    commentsTitle: '',
    title: 'sm:heading-2xl-desk heading-2xl align-top sm:!leading-none',
    count: 'sm:heading-s heading-xs align-top',
    commentsHeader: 'mt-6 flex flex-col gap-5 md:hidden',
    commentsList: 'mt-8 flex flex-col gap-8',
    comment: 'heading-s',
    author: 'heading-m-bold',
    commentHeader: 'mb-4 flex justify-between',
    createdAt: 'heading-xs text-secondary-hover',
    button: 'mb-6'
  }
});
